export const gasDetecorMetadata = {
  "o2": { "label": "gas_o2", "unit": "%", "plotRange": [0, 40] },
  "temperature": { "label": "gas_temperature", "unit": "°C", "plotRange": [0, 40] },
  "pm25": { "label": "gas_pm25", "unit": "ppm", "plotRange": [0, 70] },
  "co": { "label": "gas_co", "unit": "ppm", "plotRange": [0, 100] },
  "co2": { "label": "gas_co2", "unit": "ppm", "plotRange": [0, 7000] },
  "h2s": { "label": "gas_h2s", "unit": "ppm", "plotRange": [0, 20] },
  "ch4": { "label": "gas_ch4", "unit": "%", "plotRange": [0, 20] },
  "combustible_gas": { "label": "gas_combustibleGas", "unit": "%", "plotRange": [0, 1.5] },
}

export const smartwatchMetadata = {
  "body_temp": { "plotRange": [0, 45] },
  "heart_rate": { "plotRange": [0, 160] },
  "blood_pressure": { "plotRange": [0, 150] },
  "blood_oxygen": { "plotRange": [0, 100] },
}
